import React, {Component} from 'react'
import PropTypes from "prop-types";
import Error from "../single_components/Error";
import Select from "react-select";
import {authenticationService} from "../../services/AuthenticationService";

class ShowingReason extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
        }
    }
    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    render() {
        let {t} = this.props

        let {entry}= this.state

        return (
            <div className={'patientsFormBoxes'}>
                <div className={'inputSlotsDoc-full'}>
                        <label className={'infoLabel'}>{t('patient_boarding.ShowingReason')}</label>
                        <textarea  className={'info-inputBoxStyle2'} defaultValue={entry.ShowingReason}
                                   maxLength={5000}
                                   onChange={(event) => this.props.onValueChange("ShowingReason", event.target.value)}/>
                </div>

                    <div className={'inputSlotsDoc-full'}>
                        <label className={'infoLabel'}>{t('patient_boarding.current_Diseases')}</label>
                        <textarea  className={'info-inputBoxStyle boxMargin'} defaultValue={entry.Additional_medical_details}
                                   onChange={(event) => this.props.onValueChange("Additional_medical_details", event.target.value)}/>
                    </div>

            </div>

        )
    }
}

ShowingReason.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default ShowingReason;
